var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReduceChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1756_54288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.301344 6.93721C0.41264 6.86276 0.543502 6.82297 0.677402 6.82285H13.3231C13.457 6.82297 13.5879 6.86276 13.6992 6.93721C13.8105 7.01166 13.8972 7.11742 13.9484 7.24113C13.9996 7.36484 14.0131 7.50096 13.987 7.6323C13.9609 7.76363 13.8965 7.88429 13.8018 7.97903L7.47898 14.3019C7.35196 14.4287 7.17978 14.5 7.00025 14.5C6.82073 14.5 6.64854 14.4287 6.52152 14.3019L0.198672 7.97903C0.104049 7.88429 0.0396243 7.76363 0.0135341 7.6323C-0.0125562 7.50096 0.000858532 7.36484 0.0520839 7.24113C0.103309 7.11742 0.190048 7.01166 0.301344 6.93721ZM7.00025 12.8657L11.6882 8.17775H2.31231L7.00025 12.8657ZM1.58071 0.500003H12.4199C12.8384 0.502374 13.2391 0.669674 13.535 0.965602C13.8309 1.26153 13.9982 1.66222 14.0006 2.08072V3.88724C13.9982 4.30574 13.8309 4.70643 13.535 5.00236C13.2391 5.29829 12.8384 5.46559 12.4199 5.46796H1.58071C1.16221 5.46559 0.761529 5.29829 0.4656 5.00236C0.169671 4.70643 0.00237116 4.30574 0 3.88724V2.08072C0.00237116 1.66222 0.169671 1.26153 0.4656 0.965602C0.761529 0.669674 1.16221 0.502374 1.58071 0.500003ZM1.42104 4.04692C1.46338 4.08927 1.52082 4.11306 1.58071 4.11306H12.4199C12.4798 4.11306 12.5372 4.08927 12.5796 4.04692C12.6219 4.00457 12.6457 3.94713 12.6457 3.88724V2.08072C12.6457 2.02083 12.6219 1.96339 12.5796 1.92104C12.5372 1.87869 12.4798 1.8549 12.4199 1.8549H1.58071C1.52082 1.8549 1.46338 1.87869 1.42104 1.92104C1.37869 1.96339 1.3549 2.02083 1.3549 2.08072V3.88724C1.3549 3.94713 1.37869 4.00457 1.42104 4.04692Z",
    fill: "#1D4ED8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1756_54288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReduceChat);
export default __webpack_public_path__ + "static/media/icon_reduce_chat.e9284914c938d91aad84cf20671c2031.svg";
export { ForwardRef as ReactComponent };